import { render, staticRenderFns } from "./PayrunPeriodWizard.vue?vue&type=template&id=35cef66a"
import script from "./PayrunPeriodWizard.vue?vue&type=script&lang=js"
export * from "./PayrunPeriodWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports